<template>
  <div>
    <img src="@/assets/heyitsme-icon.svg" class="back-btn-absolute" @click="$router.push('/')" alt="Home" role="button" />
    <h1 class="faq-title">Frequently Asked Questions</h1>
    <div class="faq-page">
      <div class="faq-list">
        <div class="faq-item">
          <h2>What emails will you send me, and how often?</h2>
          <p>
            Hey, It's Me will send you one of your messages
            about 3-5 times per week. If that's too little or too often, you 
            can adjust the frequency in your account settings.
            <br>
            <br>
            In addition to your own messages, Hey, It's Me uses your email 
            to send login codes and a weekly check-in that invites you to 
            add any new messages that might be on your mind that week. Lastly, 
            we will notify you by email of any important updates or changes 
            to our <router-link to="/terms" style="color: #7da47e; text-decoration: none; cursor: pointer;">Terms of Service</router-link>, <router-link to="/privacy-policy" style="color: #7da47e; text-decoration: none; cursor: pointer;">Privacy Policy</router-link>, or features and functionality.
          </p>
        </div>
        <div class="faq-item">
          <h2>How do I sign up?</h2>
          <p>
            Fill out the Sign Up form on the homepage with your name and email, 
            then click "Sign Up". Check your email for the verification code, 
            and enter it into 
            the box on the Sign Up page. After that, you're 
            ready to add your first message! Hey, It's Me is free 
            to use when you choose to have your messages delivered 
            to you by email, so you won't be asked to enter any payment 
            information or your phone number unless you choose to sign up for SMS from 
            your account settings.</p>
        </div>
        <div class="faq-item">
          <h2>How do I change my email address?</h2>
          <p>
            Log in to Hey, It's Me and click on the Account button in the top right corner. 
            There, you can update your email address. 
            The system will send you a verification 
            code, just like during sign-up, to confirm your new email 
            address before allowing you to save it.</p>
        </div>
        <div class="faq-item">
          <h2>Is my information private?</h2>
          <p>
            Yes. We do not sell your information. 
            Please read the <router-link to="/privacy-policy" style="color: #7da47e; text-decoration: none; cursor: pointer;">Privacy Policy</router-link> for more details on what 
            information we collect and how it is used. 
          </p>
        </div>
        <div class="faq-item">
          <h2>What does Hey, It's Me cost?</h2>
          <p>
            When you choose to have your messages delivered to you by email, 
            Hey, It's Me is free! There are no monthly subscription fees or 
            in-app costs. If you'd like to have your messages delivered to 
            you by text (SMS), then you will be asked to sign up for a 
            monthly subscription at $5/month. This fee is charged by Stripe, 
            the payment processor I use. You can cancel your subscription at 
            any time from your account settings by clicking Manage Subscription 
            or by switching back to email. 
            <br><br>
            Please review the <router-link to="/terms" style="color: #7da47e; text-decoration: none; cursor: pointer;">Terms of Service</router-link> and <router-link to="/privacy-policy" style="color: #7da47e; text-decoration: none; cursor: pointer;">Privacy Policy</router-link> for 
            more information, specifically the 
            cancellation and refund policy. 
            <br>
            <br>
            As a small business, we handle everything from design to creation, customer support, ongoing improvements, and covering the monthly cost of running Hey, It's Me. If you would like to <a href='https://buy.stripe.com/14A28r9XObsObx3bwh28800' style='color:#7da47e;text-decoration:none;'>support our work</a> with a donation, it would completely make our day.
          </p>
        </div>
        <div class="faq-item">
          <h2>What if I want to delete my account but keep my messages?</h2>
          <p>
            Before you delete your account, you'll be asked if you want 
            to download your messages. They'll save directly to your downloads 
            folder as a PDF.
          </p>
        </div>
        <div class="faq-item">
          <h2>Why can't I specify the exact days and times I want to receive my messages?</h2>
          <p>
            The messages from Hey, It's Me are meant to feel like they are 
            coming from a good friend. The more organic and spontaneous they come, 
            the more impactful they are.

            <br><br>
            If you have any further questions, please <router-link to="/contact" style="color: #7da47e; text-decoration: none; cursor: pointer;">contact us</router-link>!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// FAQ page component - displays frequently asked questions
// Uses Composition API for consistency with other components
</script>

<style scoped>
.back-btn-absolute {
  position: absolute;
  top: 18px;
  left: 28px;
  z-index: 1000;
  width: 88px;
  height: 88px;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.2s;
}
.back-btn-absolute:hover {
  opacity: 0.75;
}
@media (max-width: 700px) {
  .back-btn-absolute {
    top: 8px;
    left: 14px;
    width: 68px;
    height: 68px;
  }
}
.faq-page {
  max-width: 700px;
  margin: 8px auto 32px auto;
  padding: 24px 32px;
  background: #f5f5f5;
  border: 1px solid #e5e5e5; /* Match info boxes border */
  border-radius: 10px;        /* Match info boxes radius */
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  text-align: left;
}
@media (max-width: 700px) {
  .faq-page {
    max-width: 98vw;
    padding: 12px 10vw;
  }
}
.faq-title {
  text-align: center;
  font-family: 'StayWonderful', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2.5rem;
  color: #312d30;
  margin-bottom: 32px;
  font-weight: 300;
}
.faq-list {
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.faq-item h2 {
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2.0rem;
  color: #312d30;
  margin-bottom: 8px;
  font-weight: 300;
}
.faq-item p {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
  font-size: 1.08rem;
  color: #312d30;
  margin: 0;
}
</style>
